import React, { useState } from 'react';
import Icon from '../AppIcon';
import Button from './Button';
import { t } from '../../utils/translations';

const Header = ({ onMenuToggle, isMenuOpen = false }) => {



  const primaryNavItems = [
    { label: t('nav.dashboard'), path: '/dashboard', icon: 'LayoutDashboard' },
    { label: t('nav.articles'), path: '/articles-management', icon: 'FileText' },
    { label: t('nav.projects'), path: '/projects-management', icon: 'FolderOpen' },
    { label: t('nav.subUnions'), path: '/sub-unions-management', icon: 'Building2' },
  ];

  const secondaryNavItems = [
    { label: t('nav.cities'), path: '/cities-management', icon: 'MapPin' },
    { label: t('nav.offices'), path: '/offices-management', icon: 'Briefcase' },
  ];

  const handleNavigation = (path) => {
    window.location.href = path;
  };







  return (
    <header className="fixed top-0 left-0 right-0 z-100 bg-card border-b border-border shadow-elevation-1">
      <div className="flex items-center justify-between h-16 px-6">
        {/* Left Section - Mobile Menu Toggle */}
        <div className="flex items-center space-x-4">
          {/* Mobile Menu Toggle */}
          <Button
            variant="ghost"
            size="icon"
            className="lg:hidden"
            onClick={onMenuToggle}
            iconName={isMenuOpen ? 'X' : 'Menu'}
            iconSize={20}
          >
            <span className="sr-only">Toggle menu</span>
          </Button>
        </div>

        {/* Center Section - Primary Navigation (Desktop) */}
        <nav className="hidden lg:flex items-center space-x-1">
          {[...primaryNavItems, ...secondaryNavItems]?.map((item) => (
            <Button
              key={item?.path}
              variant="ghost"
              size="sm"
              className="text-muted-foreground hover:text-foreground transition-colors"
              onClick={() => handleNavigation(item?.path)}
              iconName={item?.icon}
              iconPosition="left"
              iconSize={16}
            >
              {item?.label}
            </Button>
          ))}
        </nav>
        <div className="flex items-center space-x-4">
          {/* Logo */}
          <div className="flex items-center space-x-3">

            <div className="hidden sm:block">
              <h1 className="text-lg font-semibold text-foreground font-arabic">
                الإتحاد العام لطلبة سوريا
              </h1>
              <p className="text-xs text-muted-foreground font-caption">
                {t('sidebar.adminPanel')}
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Mobile Navigation Overlay */}
      {isMenuOpen && (
        <div className="lg:hidden fixed inset-0 top-16 z-200 bg-background/80 backdrop-blur-sm">
          <div className="bg-card border-r border-border h-full w-80 shadow-elevation-3 animate-slide-up">
            <nav className="p-6 space-y-2">
              <div className="mb-6">
                <h2 className="text-lg font-semibold text-foreground font-arabic mb-2">
                  {t('nav.navigation')}
                </h2>
              </div>

              {/* Primary Navigation */}
              <div className="space-y-1">
                {primaryNavItems?.map((item) => (
                  <button
                    key={item?.path}
                    className="w-full flex items-center space-x-3 px-4 py-3 text-sm text-foreground hover:bg-muted rounded-lg transition-colors"
                    onClick={() => {
                      handleNavigation(item?.path);
                      onMenuToggle();
                    }}
                  >
                    <Icon name={item?.icon} size={18} />
                    <span>{item?.label}</span>
                  </button>
                ))}
              </div>

              <hr className="my-4 border-border" />

              {/* Secondary Navigation */}
              <div className="space-y-1">
                <h3 className="text-xs font-medium text-muted-foreground uppercase tracking-wider mb-2 font-caption">
                  {t('nav.management')}
                </h3>
                {secondaryNavItems?.map((item) => (
                  <button
                    key={item?.path}
                    className="w-full flex items-center space-x-3 px-4 py-3 text-sm text-foreground hover:bg-muted rounded-lg transition-colors"
                    onClick={() => {
                      handleNavigation(item?.path);
                      onMenuToggle();
                    }}
                  >
                    <Icon name={item?.icon} size={18} />
                    <span>{item?.label}</span>
                  </button>
                ))}
              </div>
            </nav>
          </div>
        </div>
      )}

    </header>
  );
};

export default Header;